import {
  COTIZADOR_ACT_GET_HISTORYPRICE_BEGIN,
  COTIZADOR_ACT_GET_HISTORYPRICE_SUCCESS,
  COTIZADOR_ACT_GET_HISTORYPRICE_FAILURE,
  COTIZADOR_ACT_GET_HISTORYPRICE_DISMISS_ERROR,
} from './constants'

import { BFFAgent } from '../../../common/BFFAgent'


export  function actGetHistoryPrice(args = {}) {
 
  return async (dispatch) => {
    
      dispatch({
        type: COTIZADOR_ACT_GET_HISTORYPRICE_BEGIN,
      })      
      
      try { 
        const result = await BFFAgent.Cotizador.getHistoryPrice(args)
        
        dispatch({
          type: COTIZADOR_ACT_GET_HISTORYPRICE_SUCCESS,
          data: result, // ver si es .data
        }) 
  
      } catch (error) {
        dispatch({
          type: COTIZADOR_ACT_GET_HISTORYPRICE_FAILURE,
          data: { error: error },
        })
      }
    }
    
}

export function dismissActGetHistoryPriceError() {
  return {
    type: COTIZADOR_ACT_GET_HISTORYPRICE_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COTIZADOR_ACT_GET_HISTORYPRICE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actGetHistoryPricePending: true,
        actGetHistoryPriceError: null,
      }

    case COTIZADOR_ACT_GET_HISTORYPRICE_SUCCESS:
      // The request is success
      return {
        ...state,
        actGetHistoryPricePending: false,
        actGetHistoryPriceError: null,
        HistoryPriceArray: action.data,
      }
      

    case COTIZADOR_ACT_GET_HISTORYPRICE_FAILURE:
      // The request is failed
      return {
        ...state,
        actGetHistoryPricePending: false,
        actGetHistoryPriceError: action.data.error,
      }

    case COTIZADOR_ACT_GET_HISTORYPRICE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actGetHistoryPriceError: null,
      }

    default:
      return state
  }
}
